import { render, staticRenderFns } from "./DadosComunicacaoEletronica.vue?vue&type=template&id=295738f6&scoped=true"
import script from "./DadosComunicacaoEletronica.vue?vue&type=script&lang=ts"
export * from "./DadosComunicacaoEletronica.vue?vue&type=script&lang=ts"
import style0 from "./DadosComunicacaoEletronica.vue?vue&type=style&index=0&id=295738f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295738f6",
  null
  
)

export default component.exports